import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./firebase";
import "firebase/storage";
import { rtdbPlugin } from "vuefire";

Vue.use(rtdbPlugin);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
  beforeCreate() {
    this.$store.commit("initialiseStore");
  },
}).$mount("#app");
